<template>
  <div>
    <div v-if="resetPwd">
      <ResetPwd :pwdResetToken="resetPwdToken" />
    </div>
    <div v-else-if="isAuthenticated">
      <keep-alive>
        <Main />
      </keep-alive>
    </div>
    <div v-else>
      <Login/>
    </div>
  </div>
</template>

<script>
import Login from '@/components/Login.vue'
import Main from '@/components/Main.vue'
import ResetPwd from '@/components/ResetPwd.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'home',
  components: {
    Login, 
    Main, 
    ResetPwd
  },
  computed: {
    ...mapGetters([
      'isAuthenticated'
    ])
  },
  data: () => ({
    resetPwd: false,
    resetPwdToken: '',
  }),
  created() {
    var urlParams = new URLSearchParams(window.location.search)
    if (urlParams.has('resetpwd')) {
      this.resetPwd = true
      this.resetPwdToken = urlParams.get('resetpwd')
    }
  }
}
</script>
